import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";

require('./empty-state.scss');
@Component({
  standalone: false,
  selector: 'app-empty-state',
  templateUrl: './empty-state.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent {
  @Input() src: string;
  @Input() text: string;
  @Input() description?: string;
  @Input() action: any;
  @Output() actionEvent = new EventEmitter<null>();

}
